import { Grid, Typography } from "@mui/material";
import { useState } from "react";
import { PlanType, RenewalOptions, Tier } from "../../models";
import { useData } from "../../utils/useData";
import { PlanDetailsForm } from "./PlanDetailsForm";
import { EmployerModuleType } from "../../models/accounts/employerModuleType";
import { useCreatePlan } from "../../hooks/useCreatePlan";

type EditPlanProps = {
  isPilot: boolean;
  employerModuleType: EmployerModuleType;
  handleClose: () => void;
};

export const AddPlan = ({ isPilot, handleClose, employerModuleType }: EditPlanProps) => {
  const { serviceSectors, employees, accounts } = useData();
  const [error, setError] = useState("");

  const mutationCreatePlan = useCreatePlan(employerModuleType, {
    onSuccess: () => {
      handleClose();
    },
    onError: (error: Error) => {
      setError(error.message);
    }
  });

  const handlePlanSave = async (
    name: string,
    serviceSectorIds: string[],
    tiers: Tier[],
    planType: PlanType,
    renewalOptions: RenewalOptions
  ) => {
    await mutationCreatePlan.mutate({
      name,
      serviceSectorIds,
      tiers,
      planType,
      renewalOptions,
      management: {
        canAdHocTopUp: true
      },
      payments: {
        isEnabled: false
      },
      purchases: {
        isEnabled: true
      }
    });
  };

  return (
    <>
      <PlanDetailsForm
        isPilot={isPilot}
        employees={employees.data?.items ?? []}
        accounts={accounts.data?.items ?? []}
        serviceSectors={serviceSectors.data?.items ?? []}
        isLoading={mutationCreatePlan.isLoading}
        onClose={handleClose}
        onSave={handlePlanSave}
      />
      {error && (
        <Grid item xs={12}>
          <Typography color="error">{error}</Typography>
        </Grid>
      )}
    </>
  );
};
